// Poster paths come from public/tmdb-posters.json, built ahead of time by
// scripts/build_tmdb_posters.py. Image URLs need no API key, so none reaches the browser.
const IMAGE_BASE_URL = 'https://image.tmdb.org/t/p'
const POSTER_WIDTHS = [185, 342, 500]

let posters = null
let loading = null

/** Resolves once the map is available. If it can't be loaded, titles just have no poster. */
export function loadPosters() {
  if (!loading) {
    loading = fetch(`${process.env.BASE_URL}tmdb-posters.json`)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.json()
      })
      .catch((error) => {
        console.error('Failed to load the poster map:', error)
        return {}
      })
      .then((map) => {
        posters = map
      })
  }
  return loading
}

export function postersLoaded() {
  return posters !== null
}

export function getPosterPath(ncTitleId) {
  return (posters && posters[ncTitleId]) || null
}

export function posterSrc(path) {
  return `${IMAGE_BASE_URL}/w342${path}`
}

export function posterSrcset(path) {
  return POSTER_WIDTHS.map((width) => `${IMAGE_BASE_URL}/w${width}${path} ${width}w`).join(', ')
}
